import { ProductListResponseDto } from '@epicuro-next/data/engagement/engagement-models';

const SEPARATOR = '_';

export const extractUniqueReferences = (items: ProductListResponseDto[]) => {
  const uniqueReferences = items.reduce<Set<string>>((acc, item) => {
    const referencesSet = new Set([
      ...(item?.productsReference ?? []).map(
        (ref) => `${ref.brandId}${SEPARATOR}${ref.productId}`,
      ),
    ]);

    return new Set([...acc, ...referencesSet]);
  }, new Set());

  return [...uniqueReferences].map((str) => {
    const firstSeparatorOccurrenceIndex = str.search(SEPARATOR);
    const brandId = str.substr(0, firstSeparatorOccurrenceIndex);
    const productId = str.substr(firstSeparatorOccurrenceIndex + 1);

    return {
      brandId,
      productId,
    };
  });
};
